<template>
  <div class="mcp-register">
    <h3>S'inscrire</h3>

    <div class="form-group">
      <label>Prénom</label>
      <input
        type="text"
        placeholder="Votre prénom"
        v-model="first_name"
        v-validate="'required'"
        name="first_name"
        class="form-control"
      />
      <small class="errors" v-if="errors.has('first_name')">{{ errors.first('first_name').replace('first_name', '') }}</small>
    </div>

    <div class="form-group">
      <label>Nom</label>
      <input
        type="text"
        placeholder="Votre nom"
        v-model="last_name"
        v-validate="'required'"
        name="last_name"
        class="form-control"
      />
      <small class="errors" v-if="errors.has('last_name')">{{ errors.first('last_name').replace('last_name', '') }}</small>
    </div>

    <div class="form-group">
      <label>Courriel</label>
      <input
        type="text"
        placeholder="Votre courriel"
        v-model="email"
        v-validate="'required'"
        name="email"
        class="form-control"
      />
      <small class="errors" v-if="errors.has('email')">{{ errors.first('email').replace('email', '') }}</small>
    </div>
    <hr />
    <div class="form-group">
      <label>Mot de passe</label>
      <input
        type="password"
        placeholder="Votre nom mot de passe"
        v-model="password"
        v-validate="'required'"
        name="password"
        class="form-control"
      />
      <small class="errors" v-if="errors.has('password')">{{ errors.first('password').replace('password', '') }}</small>
    </div>
    <div class="form-group">
      <label>Répétez le mot de passe</label>
      <input
        type="password"
        placeholder="Répétez votre mot de passe"
        v-model="password_confirm"
        v-validate="'required'"
        name="password_confirm"
        class="form-control"
      />
      <small class="errors" v-if="errors.has('password_confirm')">{{ errors.first('password_confirm').replace('password_confirm', '')  }}</small>
    </div>

    <button class="btn viewBtn" @click="SignUp()">S'inscrire</button>
  </div>
</template>

<script>
export default {
  name: "Inscription",
  data() {
    return {
      last_name: "",
      first_name: "",
      email: "",
      //company: "",
      //address: "",
      //city: "",
      //zipcode: "",
      //phone: "",
      password: "",
      password_confirm: ""
    };
  },
  methods: {
    SignUp: function() {
      this.$validator.validate().then(result => {
        if (!result) return; // client side error detected.
        var data = {
          last_name: this.last_name,
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          username: this.email,
          password: this.password,
          password_confirm: this.password_confirm
        };
        var dheader = { "Content-Type": "application/json" };
        this.$http
          .post(this.$url_name + "/accounts/register/", data, {
            headers: dheader
          })
          .then(response => {
            this.$toasted.show("Inscription réussi avec succès!", {
              duration: 2000,
              type: "success"
            });
            this.$router.push({
              name: "Login"
            });
          })
          .catch(err => {
            if (err.status == 400) {
              Object.keys(err.body).forEach(key => {
                if (key == "non_field_errors") {
                  this.$toasted.show(err.body[key][0].replace("Passwords don't match", "Le mot de passe n'est pas le même"), {
                      duration: 2000,
                      type: "error"
                    });
                } else {
                  this.$validator.errors.add({
                    id: err.body[key].id,
                    field: key,
                    msg: err.body[key][0],
                    scope: this.$options.scope
                  });
                }
              });
            }
          });
      });
    }
  }
};
</script>

<style scoped>
.mcp-register {
  width: 40%;
  padding: 10vh 10% 10vh 0;
  margin: 0 auto;
}
@media (max-width: 1999px) {
    .mcp-register{width:50%;padding:10vh 0}
}
@media (max-width: 1023px) {
    .mcp-register{width:75%;padding:10vh 0}
}
</style>


// WEBPACK FOOTER //
// src/components/Inscription.vue